<template>
  <div class="main-wrapper">
    <!-- Header row -->
    <div class="flex w-full py-2">
      <div class="w-4/12">
        <h6 class="opacity-50">Name</h6>
      </div>
      <div class="w-4/12">
        <h6 class="opacity-50">Amount</h6>
      </div>
      <div v-if="!hidePercent" class="w-4/12">
        <h6 class="opacity-50">No. of Transactions</h6>
      </div>
    </div>

    <!-- Data rows (terminals) -->
    <div
      class="flex w-full list-contain py-2 px-2"
      v-for="(item, index) in displayList"
      :key="item.name || index"
    >
      <div class="w-4/12">
        <span class="w-full block" :style="getColorStyle(item, index)">
          {{ item.name || "Unknown" }}
        </span>
      </div>

      <div class="w-4/12">
        <span class="w-full flex items-center">
          <abbr class="list-amount">
            ₦ {{ formatValue(item.amount || 0) }}
          </abbr>
        </span>
      </div>

      <div v-if="!hidePercent" class="w-4/12">
        <!-- <span class="text-sm opacity-80">
          {{ typeof item.percentage === "number" ? item.percentage.toFixed(2) + '%' : '—' }}
        </span> -->
        <span class="text-sm opacity-80">
          {{ item.count != null ? item.count : '—' }}
        </span>
      </div>
    </div>

    <!-- Total row -->
    <div class="flex w-full py-2 bg-gray-200 px-2 mt-2">
      <div class="w-4/12">
        <b class="w-full block">Total (₦)</b>
      </div>
      <div class="w-4/12">
        <span class="w-full block">₦ {{ totalValue }}</span>
      </div>
      <div v-if="!hidePercent" class="w-4/12">
        <!-- <span class="w-full block">
          {{ totalPercentage }}
        </span> -->
        <span class="w-full block">
          {{ totalCount }}
        </span>
      </div>
    </div>

    <!-- Optional view all -->
    <div class="flex w-full py-1 justify-end">
      <!-- <button
        class="flex items-center text-primary-yellow pr-2 mt-3"
        @click="routeToTransaction(path)"
        v-if="!viewall && path"
      >
        View all <img alt="" class="ml-1" src="@/assets/images/icons/arr.svg" />
      </button> -->
      <button
        class="flex items-center text-primary-yellow pr-2 mt-3"
        @click="openTransactionVolumesModal"
        v-if="!viewall && !showTransactionVolumesModal"
      >
        View all <img alt="" class="ml-1" src="@/assets/images/icons/arr.svg" />
      </button>
      
    </div>
       <div v-if="showTransactionVolumesModal">
      <TransactionVolumesModal :dataList="displayList" @close-TransactionVolumes-modal="closeTransactionVolumesModal" />
    </div>
  </div>
</template>

<script>

import TransactionVolumesModal from "../modals/TransactionVolumesModal.vue";

export default {
    components: {
    TransactionVolumesModal
  },
  name: "ChartList",
  props: {
    // dataList should follow: { terminals: [{name, amount, percentage, count, color?}, ...], totalAmount?, totalCount? }
    dataList: { type: Object, required: true },
    path: { type: String, default: null },
    // viewall: { type: Boolean, default: false }, // if true show all rows
    hidePercent: { type: Boolean, default: false }, // hide percentage column
    // optional palette override
    palette: {
      type: Array,
      default: () => ["#09B78A", "#D72638", "#FCC210", "#10233E", "#6C63FF", "#FF6B6B", "#4ECDC4"],
    },
  },

  data() {
    return {
      viewall: false,
      showTransactionVolumesModal: false,
      
    };
  },

  computed: {
    terminals() {
      return Array.isArray(this.dataList?.terminals) ? this.dataList.terminals : [];
    },

    // Show top 5 when viewall false
    displayList() {
      if (!this.viewall) return this.terminals.slice(0, 6);
      return this.terminals.slice();
    },

    // preferred total (formatted string)
    totalValue() {
      const total = (this.dataList && this.dataList.totalAmount != null)
        ? Number(this.dataList.totalAmount)
        : this.terminals.reduce((s, t) => s + (Number(t?.amount) || 0), 0);

      return this.formatValue(total);
    },

    totalCount() {
      return (this.dataList && this.dataList.totalCount != null)
        ? this.dataList.totalCount
        : this.terminals.reduce((s, t) => s + (Number(t?.count) || 0), 0);
    },

    // total percentage for footer (100% if totalAmount present, else sum of percentages or '—')
    // totalPercentage() {
    //   if (this.dataList && this.dataList.totalAmount != null) {
    //     // backend provided totalAmount — show 100%
    //     return "100.00%";
    //   }

    //   const sum = this.terminals.reduce((s, t) => s + (Number(t?.percentage) || 0), 0);
    //   return sum > 0 ? `${sum.toFixed(2)}%` : "—";
    // },
  },

  methods: {
     closeTransactionVolumesModal() {
      this.showTransactionVolumesModal = false;
    },
    openTransactionVolumesModal() {
      this.showTransactionVolumesModal = true;
    },
    formatValue(val) {
      const formatter = new Intl.NumberFormat("en-NG", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
      return formatter.format(Number(val || 0));
    },

    // color style: prefer item.color, else use the palette by index
    getColorStyle(item, index) {
      const color = item?.color || this.palette[index % this.palette.length];
      return `color: ${color}; font-weight: 400; font-size: 14px;`;
    },

    routeToTransaction(path) {
      if (!path) return;
      if (this.$router) {
        this.$router.push(path);
      } else {
        window.location.href = path;
      }
    },
  },
};
</script>

<style scoped>
.list-amount {
  display: block;
  white-space: nowrap;
  width: calc(100% - 80px);
  color: #10233E;
  font-size: 14px;
  font-weight: 400;
}

.list-contain:nth-child(even) {
  background: #f3f4f6; /* tailwind bg-gray-200 */
}

.main-wrapper {
  width: 100%;
  display: flex;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  flex-wrap: wrap;
}
</style>

